import { alpha, useMediaQuery, useTheme } from '@mui/material';
const useEventMetaFormStyles = () => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('xl'));
    return {
        cardContainer: {
            backgroundColor: (theme) => 'transparent',
            p: (theme) => theme.spacing(1.5),
            border: (theme) => `1px solid ${alpha(theme.palette.grey[500], 0.24)}`,
            gap: (theme) => theme.spacing(0.5),
            borderRadius: (theme) => theme.spacing(1.75)
        },
        innerScrollableContentContainer: {
            height: 'calc(100dvh - 180px)',
            padding: isSmallScreen ? 1 : undefined,
            pb: !isSmallScreen ? '70px' : undefined,
            overflow: 'auto',
            paddingRight: 1,
            // Hide scrollbar by default, show on hover
            '&::-webkit-scrollbar': {
                width: '6px',
                height: '6px'
            },
            '&::-webkit-scrollbar-track': {
                background: 'transparent'
            },
            '&::-webkit-scrollbar-thumb': {
                background: 'transparent',
                borderRadius: '3px'
            },
            '&:hover::-webkit-scrollbar-thumb': {
                background: 'rgba(0, 0, 0, 0.32)'
            },
            // Firefox scrollbar styling
            scrollbarWidth: 'thin',
            scrollbarColor: 'transparent transparent',
            '&:hover': {
                scrollbarColor: 'rgba(0, 0, 0, 0.32) transparent'
            },
            // Hide scrollbar when dropdowns are open
            '&:has(.MuiAutocomplete-popper, .MuiMenu-root, .MuiPopover-root)': {
                '&::-webkit-scrollbar-thumb': {
                    background: 'transparent !important'
                },
                scrollbarColor: 'transparent transparent !important'
            }
        }
    };
};
export default useEventMetaFormStyles;
